import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { SplitViewComponent } from '../proofreading/pages/split-view/split-view.page';
import { CanDeactivateGuard } from '../shared/guard/can-deactivate/can-deactivate-guard.service';
import { SplitViewRevisionsComponent } from '../proofreading/pages/split-view-revisions/split-view-revisions.page';
import { SplitViewInternComponent } from '../proofreading/pages/split-view-intern/split-view-intern';
import { SplitViewInternRevisionsComponent } from '../proofreading/pages/split-view-intern-revisions/split-view-intern-revisions';
import { AuthGuard } from 'src/guards/auth.guard';
import { SplitViewOldComponent } from '../proofreading/pages/split-view-old/split-view-old.page';
import { WrapperComponent } from '../wrapper/wrapper.component';
import { hasDIADEMAccessGuard } from '../shared/guard/has-access/has-diadem-acess-guard.service';

const routes: Routes = [
    {
        path: ':id',
        canDeactivate: [CanDeactivateGuard],
        component: SplitViewComponent,
    },
    {
        path: 'revisions/:id/:projectID',
        component: SplitViewRevisionsComponent,
    },
    {
        path: 'intern/:id',
        component: SplitViewInternComponent,
        canActivate: [hasDIADEMAccessGuard],
    },
    {
        path: 'splitview/intern/revisions/:id/:projectID',
        component: SplitViewInternRevisionsComponent,
        canActivate: [hasDIADEMAccessGuard],
    },
    {
        path: 'old/:id',
        component: SplitViewOldComponent,
    },
];

@NgModule({
    imports: [
        CommonModule,
        RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class SplitViewRoutingModule { }
